module.exports = __webpack_public_path__ + "static/img/guangzhou.fcdf130.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guangzhou.jpg
// module id = 9aeE
// module chunks = 1